import LabelIcon from './LabelIcon';

export default LabelIcon;
